import { render, staticRenderFns } from "./crearPromocion.vue?vue&type=template&id=e5600c88&scoped=true&"
import script from "./crearPromocion.vue?vue&type=script&lang=js&"
export * from "./crearPromocion.vue?vue&type=script&lang=js&"
import style0 from "./crearPromocion.vue?vue&type=style&index=0&id=e5600c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5600c88",
  null
  
)

export default component.exports